module.exports = __webpack_public_path__ + "media/packs/images/flags/AU-44419a7ddfff6b5ce1d2ae238be353e9.png";